import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { JVDropdown } from "../../../../shared/JVDropdown";
import { Toast } from "primereact/toast";
import { Table } from "./Table";
import { IPermissionProps } from "../../../../models/Login";
import { Form } from "./Form";
import { TopicLink } from "./TopicLink";

interface IProps {
    open: boolean,
    singleData: any,
    hideDialog: () => void,
    toast: any,
}

export const TrainingCategory = (permission: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as { open: boolean, singleData: any });
    const [reload, setReload] = useState(false);
    const [topicModal, setTopicModal] = useState<{ open: boolean; category_ID: number | null; }>({ open: false, category_ID: null });
    const toast = useRef<any>(null);

    const hideDialog = () => setModal({ singleData: {}, open: false });
    const reloadTable = () => setReload(!reload);

    return (
        <>
            {(permission.is_Create || permission.is_Update) && <Form open={modal.open} singleData={modal.singleData} hideDialog={hideDialog} reloadTable={reloadTable} toast={toast} />}
            <Table setModal={setModal} permissions={permission} reload={reload} toast={toast} openTopicModal={(category_ID: number) => setTopicModal({ open: true, category_ID })} />
            <TopicLink open={topicModal.open} category_ID={topicModal.category_ID} hideDialog={() => setTopicModal({ open: false, category_ID: null })} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}